import EventActionProto from '../event-action-proto';

module.exports = class EventNoteTypeNew extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {
        if (!gd.session.noteTypes.get(this.data['id'])) {
            gd.session.noteTypes.add([this.data],{parse:true});
        } else {
            console.error("not meant to happen...");
        }

        super.process();
    }
};

